export const Settings = {
  MAX_AGE: 110,
  MIN_AGE: 18
};